// @flow
/** @jsx jsx */

import { jsx } from '@emotion/core';

const arrowCss = (fillColor: string) => ({
  display: 'block',
  fill: fillColor,
});

// Given a width and height (`w` and `h`), returns an object
// representing the width and height of the arrow as well as
// the drawing instructions (`d`). Note that the arg _names_
// are intentionally flipped for vertical vs horizontal.
const arrows = {
  down: (w, h) => ({ w, h, d: `M 0,0 L ${w / 2},${h} ${w},0` }),
  left: (h, w) => ({ w, h, d: `M ${w},0 L 0,${h / 2} ${w},${h}` }),
  right: (h, w) => ({ w, h, d: `M 0,0 L ${w},${h / 2} 0,${h}` }),
  up: (w, h) => ({ w, h, d: `M 0,${h} L ${w / 2},0 ${w},${h}` }),
};

type PopOverArrowProps = {
  fillColor: string,
  /** Arrow direction */
  direction: 'down' | 'left' | 'right' | 'up',
  longLen: number,
  shortLen: number,
  borderColor: string,
};

const PopoverArrow = ({
  fillColor,
  direction,
  longLen,
  shortLen,
  borderColor,
}: PopOverArrowProps) => {
  const { d, h, w } = arrows[direction](longLen, shortLen);

  return (
    <svg css={arrowCss(fillColor)} height={h} width={w}>
      <path d={d} stroke={borderColor} />
    </svg>
  );
};

PopoverArrow.defaultProps = {
  longLen: 20,
  shortLen: 10,
};

export default PopoverArrow;
